import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DiaryApi, FindByEntitySectionOptions } from 'api';

export const findByEntitySection = createAsyncThunk(
  'area/findByEntitySection',
  async (
    params: { entitySectionID: string; options: FindByEntitySectionOptions },
    { rejectWithValue }
  ) => {
    try {
      const { entitySectionID, options } = params;
      const response = await DiaryApi.findByEntitySection(
        entitySectionID,
        options
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const diarySlice = createSlice({
  name: 'diary',
  initialState: {
    tableList: [],
    list: [],
  },
  reducers: {},
  extraReducers: {},
});

const { reducer: diaryReducer } = diarySlice;

export default diaryReducer;
